import 'featherlight';
import './../../node_modules/featherlight/src/featherlight.gallery.js';
//import Instafeed from 'instafeed.js';
import './../../node_modules/bootstrap-sass/assets/javascripts/bootstrap.js';
import './../../node_modules/lazyloadxt/src/jquery.lazyloadxt.js';
import './../../node_modules/lazyloadxt/src/jquery.lazyloadxt.video.js';
import 'slick-carousel';
import axios from 'axios';
//import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

(function ($) {
  $(document).ready(function () {
    $('img').lazyLoadXT({ show: true });

    var profet = {
      elements: {
        headerDesktop: $('#header-desktop'),
        hiddenHeaderElements: [],
      },

      variables: {
        previousScroll: 0,
        currentScroll: 0,
        scrollPosOnMenuToggle: 0,
        scrollDirection: false,
        themeDir: '/wp-content/themes/nordiskakliniken/',
        imageDir: '/wp-content/themes/nordiskakliniken/dist/images/',
        maps: {
          mapInstance: false,
          markers: [],
          directionsService: false,
          directionsDisplay: false,
        },
        instaFeedIndex: 0,
        videoSliderIsDragging: false,
        heroVideoStarted: false,
        heroVideoListenersBound: false,
        visibleInstaImages: [],
        searchPlaceholders: [
          'Bröstförstoring',
          'Ansikte',
          'Boka tid',
          'Fettsugning',
          'Rynkbehandling',
          'Frågor och svar',
          'Priser',
          'Kropp',
          'Produkter',
          'Mommy makeover',
          'Dermapen',
          'Trygghetsgaranti',
          'Läppar',
          'Bildgalleri',
          'Hud',
        ],
      },

      init: function () {
        // WP admin bar adds `html { margin-top: ... !important; }` for logged-in users.
        // On mobile hero pages we want the hero flush to the top, so remove that offset by
        // adding a class to <html> (CSS is scoped to mobile).
        if (
          $('body').hasClass('has-hero-header') &&
          window.innerWidth <= 782 &&
          document.getElementById('wpadminbar')
        ) {
          document.documentElement.classList.add('nk-no-adminbar-offset');
        }

        profet.fadeInWhenInView();
        profet.handleResize();
        profet.handleScroll();
        profet.handleClicks();
        profet.setupScrollDirectionVariable();
        profet.setupSlick();
        profet.setupCookiebar();
        profet.setupInstafeed();
        profet.setMenuElementsToToggle();
        profet.setSwipeContainerText();
        profet.generateTableOfContents();
        profet.setupFaq();
        profet.handleInputFileChange();
        profet.setupMap();
        profet.setupAgeVerification();
        profet.setupImageGallery();
        profet.setupMobileMenu();
        profet.setupSearchPlaceholderCarousel();
        profet.setupPartPaymentSlider();
        profet.setupYoutubeVideoPlayer();
        profet.handleDesktopHeader();
        profet.setupContactForm7Tracking();
        profet.setupContactClickTracking();
        profet.detectBrowser();
        profet.setupVideoLoading();
        profet.maybeShowRedirectModal();
        profet.filterPlaylist();
        profet.hideThumbnail();
        profet.videosHeroSearch();
        profet.singleVideoTemplate();
        profet.selectPlaylistByQueryParameter();
      },

      handleResize: function () {
        $(window).on('resize', function () {});
      },

      handleScroll: function () {
        $(window).on('scroll', function (event) {
          if ($('body').hasClass('disable-scroll')) {
            event.preventDefault();
            return false;
          }

          profet.showBookTimePopup();
          profet.showBannerPopup();
          profet.fadeOutWhenNotInView();
          profet.fadeInWhenInView();
          profet.setupVideoLoading();
        });

        /* Scroll to Contact Form 7 output, if it's visible */
        var wpcf7Output = $('.wpcf7-response-output');
        if (wpcf7Output.is(':visible')) {
          $('html, body').animate(
            {
              scrollTop: wpcf7Output.offset().top - 100,
            },
            500
          );
        }
      },

      handleClicks: function () {
        $('.close-redirect-modal').on('click', function () {
          $('.redirect-overlay').fadeOut();
        });

        $('.turn-on-sound').on('click', function (event) {
          event.preventDefault();
          profet.videoMuteToggle($(this));
        });

        $('video[data-youtube-id]').on('click', function (event) {
          event.preventDefault();

          profet.loadYoutubeVideo($(this));
        });

        $('.toggle-hamburger-menu-desktop').on('click', function (event) {
          event.preventDefault();
          $('.desktop-header-logo').toggleClass('desktop-header-logo-faded');
          profet.elements.headerDesktop
            .find('.menu-item-hidden')
            .toggleClass('menu-item-show');

          $(this).toggleClass('toggled');
          profet.elements.headerDesktop.toggleClass('menu-expanded');

          if (profet.elements.headerDesktop.hasClass('toggled')) {
            window.setTimeout(function () {
              profet.elements.headerDesktop.toggleClass('toggled');
            }, 750);
          } else {
            profet.elements.headerDesktop.toggleClass('toggled');
          }
        });

        $('a[data-toggle-slide]').on('click', function (event) {
          event.preventDefault();
          var elementToToggle = $(this).data('toggle-show');
          elementToToggle.slideToggle();
        });

        $('.toggle-treatment-menu').on('click', function (event) {
          event.preventDefault();
          let treatmentsMenu = $('#treatments-menu');
          treatmentsMenu.slideToggle();
          treatmentsMenu.toggleClass('treatment-menu-open');
          let menuIsOpen = treatmentsMenu.hasClass('treatment-menu-open');
          if (menuIsOpen) {
            if (!profet.elements.headerDesktop.hasClass('with-background')) {
              profet.elements.headerDesktop.addClass('with-background');
            }
          } else {
            /* Remove the main header background color if the main header isn't fixed, i.e. if user is at the top of the page */
            if (!profet.elements.headerDesktop.hasClass('menu-fixed')) {
              window.setTimeout(() => {
                profet.elements.headerDesktop.removeClass('with-background');
              }, 500);
            }
          }
        });

        $('.accept-cookies').on('click', function (event) {
          event.preventDefault();
          $('.profet-cookies-info').fadeOut(250);
          profet.setCookie('nk_cookie_accept', 'true', 365);
        });

        /* Accordion stuff */
        $('.nk-accordion-top').on('click', function (event) {
          event.preventDefault();
          var accordionID = $(this).data('nk-accordion-toggle');
          var accordionElement = $(accordionID);
          accordionElement.slideToggle();
          $(this).toggleClass('accordion-toggled');
        });

        /* Handle video playlist list item click */
        $('a[data-nk-video-target]').on('click', function (event) {
          event.preventDefault();
          profet.loadYoutubeVideoFromPlaylist($(this));
        });

        /* Handle click on Read more button */
        $('a.read-more').on('click', function (event) {
          event.preventDefault();
          /* Get the target element */
          var targetElement = $(this).siblings('.read-more-target');
          /* If we coulnd't find the target, move up one level and try again */
          if (targetElement.length != true) {
            var targetElement = $(this).parent().siblings('.read-more-target');
          }

          /* Get the total height of the child elements */
          var childrenHeight = 0;
          targetElement.children().each(function () {
            childrenHeight += $(this).outerHeight();
          });

          if ($(this).attr('data-clicked-text')) {
            var tempText = $(this).html();
            $(this).html($(this).attr('data-clicked-text'));
            $(this).attr('data-clicked-text', tempText);
          }

          /* Toggle plus/minus class */
          if (!$(this).hasClass('animate-plus-icon')) {
            if ($(this).hasClass('link-plus-right')) {
              $(this).removeClass('link-plus-right');
              $(this).addClass('link-close-right');
            } else if ($(this).hasClass('link-close-right')) {
              $(this).removeClass('link-close-right');
              $(this).addClass('link-plus-right');
            }
          } else {
            $(this).toggleClass('accordion-open');
          }

          targetElement.toggleClass('read-more-expanded');

          if (targetElement.attr('style')) {
            targetElement.attr('style', '');
          } else {
            targetElement.css('maxHeight', childrenHeight * 2);
            window.setTimeout(function () {
              targetElement.css('maxHeight', 'none');
            }, 500);
          }
        });

        /* Handle click on Share blog post link */
        $('.share-link-target').on('click', function (event) {
          event.preventDefault();
          $(this).toggleClass('link-plus-right');
          $(this).toggleClass('link-close-right');
          $('.share-links').toggleClass('share-links-open');
        });

        /* Smooth scroll on anchors */
        $(document).on('click', 'a[href^="#"]', function (event) {
          event.preventDefault();

          var element = $($(this).attr('href'));
          if (!element.length) {
            return;
          }

          $('html, body').animate(
            {
              scrollTop: $($.attr(this, 'href')).offset().top - 100,
            },
            500
          );
        });

        /* Handle click on FAQ links */
        $('.select-faq-category').on('click', function (event) {
          profet.selectFaqCategory($(this));
        });

        /* Handle click on FAQ Show more link */
        $('.faq-show-all').on('click', function (event) {
          var thisListItem = $(this).closest('li');
          var hiddenListItems = thisListItem.siblings('.faq-hidden');
          thisListItem.hide();
          hiddenListItems.fadeIn(250);
        });

        /* Hide the treatments menu when the user clicks outside it */
        $('#content').on('click', function (event) {
          var treatmentsMenu = $('#treatments-menu');
          if (treatmentsMenu.is(':visible')) {
            treatmentsMenu.slideToggle();
          }
        });

        /* Hide financing modal on close click */
        $('.financing-modal-close').on('click', function () {
          $('body').removeClass('modal-open');
          $('.finance-popup').removeClass('modal-show');
        });
        /* Open financing modal on click */
        $('.financing-modal-open').on('click', function (event) {
          event.preventDefault();
          $('body').addClass('modal-open');
          $('.finance-popup').addClass('modal-show');

          /* 
					Fix issue where the financing iframe content doesn't load correctly if we load the iframe while it's outside the view of the user.
					To fix this, we load the iframe when the user clicks to show the modal.
					*/
          var financingIframe = document.querySelector('#financing-iframe');
          if (financingIframe) {
            window.setTimeout(function () {
              if (!financingIframe.src) {
                financingIframe.src = financingIframe.getAttribute('data-src');
              }
            }, 1500);
          }
        });
      },

      setupScrollDirectionVariable: function () {
        $(document).on('scroll', function (event) {
          profet.variables.currentScroll = $(this).scrollTop();
          if (
            profet.variables.currentScroll > profet.variables.previousScroll
          ) {
            profet.variables.scrollDirection = 'down';
          } else {
            profet.variables.scrollDirection = 'up';
          }
          profet.variables.previousScroll = profet.variables.currentScroll;
        });
      },

      handleDesktopHeader: function () {
        /* Set the body padding equal to the header's height */
        if (profet.elements.headerDesktop.is(':visible')) {
          // Some environments (stage) can miss `has-hero-header` even when a hero exists.
          // Use DOM presence as fallback to avoid pushing the hero down.
          var hasHeroHeader =
            $('body').hasClass('has-hero-header') ||
            $('body').hasClass('blog') ||
            $('body').hasClass('single-post') ||
            $('.profet-hero-header').length ||
            // Older hero variants still include this inner wrapper even if the outer class differs.
            $('.profet-hero-header--content').length;

          if (!hasHeroHeader) {
            $('body').animate(
              { paddingTop: profet.elements.headerDesktop.outerHeight() },
              250
            );
          }
        }

        /* Force visible logo if there's no header image */
        var headerLogo = $('.desktop-header-logo');
        // Only force the center logo when there is truly no hero present.
        // (On blog/post heroes the center logo should stay hidden until scroll.)
        if (!hasHeroHeader) {
          headerLogo.addClass('desktop-header-logo-force-show');
        } else {
          headerLogo.removeClass('desktop-header-logo-force-show');
        }

        //var profet.elements.headerDesktop;
        $(document).on('scroll', function () {
          /* If we're on Internet Explorer, don't do anything */
          if ($('body').hasClass('ms-ie')) {
            return;
          }

          //profet.variables.currentScroll
          var windowHeight = $(window).outerHeight();
          var headerDesktop = profet.elements.headerDesktop;
          var headerLogo = $('.desktop-header-logo');

          /* Remove the .menu-fixed class if the user scrolls back up to the top of the page */
          if (headerDesktop.hasClass('menu-fixed')) {
            if (profet.variables.currentScroll == 0) {
              headerDesktop.removeClass('menu-fixed');
              headerDesktop.removeClass('menu-slide-down');
              headerLogo.removeClass('desktop-header-logo-visible');
              return;
            }
          }

          /* If the search box or the header submenu is open, don't do anything... */
          if (
            $('.search-results-wrapper').is(':visible') ||
            $('.header-desktop-subnav').is(':visible')
          ) {
            if (!headerDesktop.hasClass('menu-fixed')) {
              headerDesktop.addClass('menu-fixed');
            }
            return;
          }

          if (profet.variables.currentScroll > windowHeight / 2) {
            headerDesktop.addClass('menu-fixed');
            if (!headerDesktop.hasClass('menu-slide-down')) {
              headerDesktop.addClass('menu-slide-down');
            }
            if (!headerLogo.hasClass('desktop-header-logo-visible')) {
              headerLogo.addClass('desktop-header-logo-visible');
            }
          }

          if (profet.variables.currentScroll < windowHeight / 2) {
            if (headerLogo.hasClass('desktop-header-logo-visible')) {
              headerLogo.removeClass('desktop-header-logo-visible');
            }
          }
          if (profet.variables.currentScroll <= 0) {
            if (headerLogo.hasClass('desktop-header-logo-visible')) {
              headerLogo.removeClass('desktop-header-logo-visible');
            }
          }

          if (
            profet.variables.currentScroll > windowHeight * 2.5 &&
            profet.variables.scrollDirection == 'down'
          ) {
            if (headerDesktop.hasClass('menu-slide-down')) {
              headerDesktop.removeClass('menu-slide-down');
              headerDesktop.addClass('menu-slide-up');
            } else {
              headerDesktop.removeClass('menu-slide-up');
              headerDesktop.addClass('menu-slide-down');
            }
          }

          if (profet.variables.scrollDirection == 'up') {
            if (!headerDesktop.hasClass('menu-fixed')) {
              headerDesktop.addClass('menu-fixed');
            }
            if (!headerDesktop.hasClass('menu-slide-down')) {
              headerDesktop.addClass('menu-slide-down');
            }

            headerDesktop.removeClass('menu-slide-up');
          }
        });
      },

      /* Generate a random string */
      makeId: function () {
        var text = '';
        var possible =
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

        for (var i = 0; i < 8; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return text;
      },

      convertToSlug: function (text) {
        return text
          .toLowerCase()
          .replace(/ /g, '-')
          .replace(/[^\w-]+/g, '');
      },

      /* Show swipe container text if the container it is in is overflowing the page */
      setSwipeContainerText: function () {
        var swipeContainers = $('.swipe-container');
        swipeContainers.each(function () {
          let totalButtonSize = 0;
          $(this)
            .find('.nk-button')
            .each(function () {
              totalButtonSize += $(this).outerWidth();
            });
          if (totalButtonSize / 1.7 > $(window).width()) {
            $(this).find('.swipe-text').removeClass('hidden');
          }
        });
      },

      setMenuElementsToToggle: function () {
        var hiddenHeaderElements = $(profet.elements.headerDesktop).find(
          '#primary-navigation > li:hidden'
        );
        profet.elements.hiddenHeaderElements = hiddenHeaderElements;
      },

      /*

			videoMuteToggle: function(element) {
				var videoId = element.attr('data-video-id');
				var videoElement = document.getElementById(videoId);
				if(videoElement.muted === false) {
					videoElement.muted = true;
					element.find('.muted').show();
					element.find('.not-muted').hide();
				}
				else {
					videoElement.pause();
					videoElement.currentTime = 0;
					videoElement.play();
					element.find('.muted').hide();
					element.find('.not-muted').show();
					videoElement.muted = false;
				}
			},
			*/

      setupMobileInstaFeed() {
        let index = 0;
        let fullMarkup = '';
        for (var i in profet.variables.visibleInstaImages) {
          let startWrapper = false;
          let endWrapper = false;
          if (
            index == 0 ||
            index == 4 ||
            index == 8 ||
            index == 12 ||
            index == 16 ||
            index == 20
          ) {
            startWrapper = true;
          }
          if (
            index == 3 ||
            index == 7 ||
            index == 11 ||
            index == 15 ||
            index == 19 ||
            index == 23
          ) {
            endWrapper = true;
          }
          var img = profet.variables.visibleInstaImages[i];
          var markup =
            '<div class="mobile-instagram-feed-item" data-index="' +
            index +
            '"><img src="' +
            img.image +
            '"></div>';
          if (startWrapper) {
            markup =
              '<div class="group-outer-wrapper"><div class="mobile-instagram-feed-item-group" data-index="' +
              index +
              '">' +
              markup;
          }
          if (endWrapper) {
            markup = markup + '</div></div>';
          }
          index++;
          fullMarkup += markup;
        }
        $('#mobile-instagram-feed').append(fullMarkup);
        var options = {
          arrows: false,
          dots: true,
          infinite: false,
          slidesToShow: 1,
          swipeToSlide: true,
          //appendDots: '.instagram-mobile-dots-container',
        };
        $('#mobile-instagram-feed').slick(options);
      },

      setupInstafeed: function () {
        var instafeed = $('#instafeed');
        if (instafeed.length == 0) {
          return;
        }

        /* Make an axios call to get the access token */
        axios
          .get('/wp-json/nk/getInstagramAccessToken')
          .then((response) => {
            if (
              !response ||
              !response.data ||
              !response.data.data ||
              !response.data.data.token
            ) {
              return;
            }

            const accessToken = response.data.data.token;
            profet.variables.instaFeedIndex = 0;
            profet.variables.visibleInstaImages = [];

            var feed = new Instafeed({
              get: 'user',
              filter: function (image) {
                //return image.tags.indexOf('TAG_NAME') >= 0;
                if (profet.variables.instaFeedIndex > 15) {
                  return false;
                }
                if (
                  $.inArray(image.id, profetWPVars.excludedInstagramImages) !==
                  -1
                ) {
                  return false;
                }
                profet.variables.instaFeedIndex += 1;
                var instaImage = {
                  id: image.id,
                  image: image.image,
                };

                profet.variables.visibleInstaImages.push(instaImage);

                return true;
              },
              userId: '17841401685165668',
              accessToken: accessToken,
              limit: 16,
              template:
                '<a href="{{link}}" target="_blank"><div class="slick-blog-feed-item"><img src="{{image}}" /></div></a>',
              resolution: 'standard_resolution',
              after: function () {
                var blogAndInstafeedOptions = {
                  //arrows: true,
                  arrows: false,
                  dots: true,
                  infinite: false,
                  slidesToShow: 3.2,
                  swipeToSlide: true,
                  prevArrow:
                    '<a class="slick-arrow arrow-prev"><img src="' +
                    profet.variables.themeDir +
                    'dist/images/chevron-left.svg"></a>',
                  nextArrow:
                    '<a class="slick-arrow arrow-next"><img src="' +
                    profet.variables.themeDir +
                    'dist/images/chevron-right.svg"></a>',
                  responsive: [
                    {
                      breakpoint: 768,
                      settings: {
                        arrows: false,
                        slidesToShow: 1.4,
                      },
                    },
                  ],
                  //appendDots: '.instagram-dots-container',
                };
                $('#instafeed').slick(blogAndInstafeedOptions);
                for (var i in profet.variables.visibleInstaImages) {
                  var img = profet.variables.visibleInstaImages[i];
                  var markup =
                    '<div class="instagram-admin-feed-single-item"><img src="' +
                    img.image +
                    '"><p>' +
                    img.id +
                    '</p></div>';
                  $('.instagram-admin-feed').append(markup);
                }

                profet.setupMobileInstaFeed();
              },
            });

            feed.run();
          })
          .catch((error) => {});
      },

      setupSlick: function () {
        var blogAndInstafeedOptions = {
          //arrows: true,
          arrows: false,
          dots: true,
          infinite: false,
          //slidesToShow: 2.6,
          slidesToShow: 3.4,
          swipeToSlide: true,
          prevArrow:
            '<a class="slick-arrow arrow-prev"><img src="' +
            profet.variables.themeDir +
            'dist/images/chevron-left.svg"></a>',
          nextArrow:
            '<a class="slick-arrow arrow-next"><img src="' +
            profet.variables.themeDir +
            'dist/images/chevron-right.svg"></a>',
          //appendDots: '.blog-feed-dots-container',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                slidesToShow: 1.4,
              },
            },
          ],
        };

        // Base options used across sliders.
        // NOTE: We keep "blog feed slider" options separate from "extra sliders" options.
        // The blog feed slider applies a desktop-only variableWidth tweak; we do NOT want
        // that to leak into other sliders (it makes cards render huge on non-blog pages).
        let blogFeedOptions = Object.assign({}, blogAndInstafeedOptions);
        blogFeedOptions.slidesToShow = 2.6;
        blogFeedOptions.speed = 150;

        let extraSliderOptions = Object.assign({}, blogAndInstafeedOptions);
        extraSliderOptions.slidesToShow = 2.6;
        extraSliderOptions.speed = 150;

        // Frontpage "Blogginlägg" slider: cap card width on desktop.
        // Without this, slidesToShow makes cards scale huge on wide screens.
        try {
          if (window.matchMedia && window.matchMedia('(min-width: 992px)').matches) {
            blogFeedOptions = Object.assign({}, blogFeedOptions, {
              slidesToShow: 1,
              variableWidth: true,
              centerMode: false,
            });
          }
        } catch (e) {}

        $('.slick-blog-feed-slider').slick(blogFeedOptions);

        function initExtraSlider($slider, options) {
          if (!$slider || !$slider.length) {
            return;
          }
          // If there is only one item, don't initialize slick (avoid lonely centered slide)
          if ($slider.children().length <= 1) {
            $slider.addClass('nk-slick-single');
            $slider.closest('.nk-blog-extra-slider').addClass('nk-blog-extra-slider--single');
            return;
          }
          $slider.slick(options);
        }

        function initExtraSliderWithDots($slider, options, dotsSelector) {
          if (!$slider || !$slider.length) {
            return;
          }
          $slider.each(function () {
            var $s = $(this);
            var opts = Object.assign({}, options);
            if (dotsSelector) {
              var $dots = $s.closest('.nk-blog-extra-slider').find(dotsSelector);
              if ($dots && $dots.length) {
                opts.appendDots = $dots;
              }
            }
            initExtraSlider($s, opts);
          });
        }

        // Blog page extra sliders
        // On single blog posts: use variableWidth so the portrait card width drives slide width
        if ($('body').hasClass('single-post')) {
          let singlePostExtraSliderOptions = Object.assign({}, extraSliderOptions, {
            slidesToShow: 1,
            variableWidth: true,
            centerMode: false,
          });
          initExtraSliderWithDots(
            $('.slick-blog-staff-slider'),
            singlePostExtraSliderOptions,
            '.nk-blog-staff-dots-container'
          );
          initExtraSliderWithDots(
            $('.slick-blog-posts-secondary-slider'),
            singlePostExtraSliderOptions,
            '.nk-blog-posts-secondary-dots-container'
          );

          var $singlePostExtraSliders = $('.slick-blog-staff-slider, .slick-blog-posts-secondary-slider');

          // Ensure widths are recalculated after images/fonts load
          setTimeout(function () {
            $singlePostExtraSliders
              .filter('.slick-initialized')
              .slick('setPosition');
          }, 250);
          $(window).on('load', function () {
            $singlePostExtraSliders
              .filter('.slick-initialized')
              .slick('setPosition');
          });
        } else {
          // Everywhere else: keep the same base feel as blog feed.
          // On wide screens, force variableWidth so cards don't grow gigantic on full-width layouts.
          let desktopExtraSliderOptions = extraSliderOptions;
          try {
            if (window.matchMedia && window.matchMedia('(min-width: 992px)').matches) {
              desktopExtraSliderOptions = Object.assign({}, extraSliderOptions, {
                slidesToShow: 1,
                variableWidth: true,
                centerMode: false,
              });
            }
          } catch (e) {}

          initExtraSliderWithDots(
            $('.slick-blog-staff-slider'),
            desktopExtraSliderOptions,
            '.nk-blog-staff-dots-container'
          );
          initExtraSliderWithDots(
            $('.slick-blog-posts-secondary-slider'),
            desktopExtraSliderOptions,
            '.nk-blog-posts-secondary-dots-container'
          );
        }

        // Staff slider: "Läs mer" toggles between short and long preview (never full bio).
        $(document).off('click.nkStaffBioToggle').on('click.nkStaffBioToggle', '.nk-blog-staff-toggle', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var $btn = $(this);
          var $card = $btn.closest('.slick-blog-feed-item');
          if (!$card.length) return;

          var expanded = $card.hasClass('is-expanded');
          $card.toggleClass('is-expanded', !expanded);
          $btn.attr('aria-expanded', (!expanded).toString());
          $btn.text(!expanded ? 'Visa mindre' : 'Läs mer');

          // Make toggle work even without CSS (e.g. editor preview)
          var $short = $card.find('.nk-blog-staff-bio__short');
          var $long = $card.find('.nk-blog-staff-bio__long');
          if ($short.length && $long.length) {
            if (!expanded) {
              $short.hide();
              $long.show();
            } else {
              $long.hide();
              $short.show();
            }
          }

          // Recalculate slick heights/positions after expanding.
          var $slider = $btn.closest('.nk-blog-extra-slider').find('.slick-blog-staff-slider');
          if ($slider && $slider.length && $slider.hasClass('slick-initialized')) {
            $slider.slick('setPosition');
          }
        });

        $('.slick-large-image-slider').slick({
          arrows: true,
          prevArrow:
            '<a class="slick-arrow arrow-prev"><img src="' +
            profet.variables.themeDir +
            'dist/images/chevron-left.svg"></a>',
          nextArrow:
            '<a class="slick-arrow arrow-next"><img src="' +
            profet.variables.themeDir +
            'dist/images/chevron-right.svg"></a>',
          dots: true,
          autoplay: true,
          autoplaySpeed: 3000,
          infinite: false,
          slidesToShow: 1,
          swipeToSlide: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
              },
            },
          ],
        });

        var videoSliderTracks = $('.videos-slider__track');
        if (videoSliderTracks) {
          videoSliderTracks.each(function () {
            $(this).slick({
              arrows: false,
              dots: true,
              autoplay: false,
              infinite: false,
              slidesToShow: 1,
              swipeToSlide: true,
              pauseOnHover: false,
              pauseOnFocus: false,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    arrows: false,
                  },
                },
              ],
            });

            var videos = $(this).find('.video');

            $(this).on(
              'beforeChange',
              function (event, slick, currentSlide, nextSlide) {
                profet.variables.videoSliderIsDragging = true;

                let activeSlide = videos[currentSlide];
                let slideIframe = activeSlide.querySelector('iframe');
                if (slideIframe) {
                  slideIframe.contentWindow.postMessage(
                    '{"event":"command","func":"stopVideo","args":""}',
                    '*'
                  );
                }
              }
            );

            $(this).on(
              'afterChange',
              function (event, slick, currentSlide, nextSlide) {
                profet.variables.videoSliderIsDragging = false;

                let activeSlide = videos[currentSlide];
                let slideIframe = activeSlide.querySelector('iframe');
                if (slideIframe) {
                  slideIframe.contentWindow.postMessage(
                    '{"event":"command","func":"stopVideo","args":""}',
                    '*'
                  );
                }
              }
            );

            if (videos) {
              videos.each(function () {
                let iframe = $(this).find('iframe');
                $(this)
                  .find('.video__thumbnail')
                  .on('click', function () {
                    if (profet.variables.videoSliderIsDragging != false) {
                      return;
                    }
                    $(this).hide();
                    iframe[0].contentWindow.postMessage(
                      '{"event":"command","func":"playVideo","args":""}',
                      '*'
                    );
                  });
              });
            }
          });
        }

        var selectedVideosTracks = $(
          '.din-resa-hero__selected-videos .videos-slider'
        );
        if (selectedVideosTracks) {
          selectedVideosTracks.each(function () {
            $(this).slick({
              arrows: false,
              dots: false,
              autoplay: false,
              infinite: false,
              variableWidth: true,
              swipeToSlide: true,
              pauseOnHover: false,
              pauseOnFocus: false,
            });
          });
        }
      },

      filterPlaylist: function () {
        var playlistsDropdown = $('.playlists-block .playlists__dropdown');
        var playlistLinks = $('.playlists-block .playlists__link');
        var videos = $('.playlists-block .video');

        var playlistsMobile = document.querySelector(
          '.playlists.playlists--mobile'
        );

        if (playlistsDropdown && videos) {
          playlistsDropdown.on('change', function () {
            if (this.value == 'all') {
              videos.show();
            } else {
              videos.hide();
              var value = this.value;
              videos.each(function () {
                var videoPlaylists = $(this).attr('data-id');
                var videoPlaylistsJson = JSON.stringify(videoPlaylists);
                if (videoPlaylistsJson.includes(value)) {
                  $(this).show();
                }
              });

              //$('.playlists-block .video[data-id="'+ this.value +'"]').show();
            }
            playlistsMobile.classList.remove('link-close-right');
          });

          var body = document.querySelector('body');

          playlistsDropdown.on('click', (e) => {
            if (!playlistsMobile.classList.contains('link-close-right')) {
              playlistsMobile.classList.add('link-close-right');
            }
          });
          $(document).on('click', (e) => {
            console.log(e.target);
            if (
              playlistsMobile.classList.contains('link-close-right') &&
              !e.target.parentElement.classList.contains('playlists--mobile') &&
              !e.target.classList.contains('playlists__dropdown')
            ) {
              playlistsMobile.classList.remove('link-close-right');
            }
          });

          /* If a playlist is selected, append that playlist to the end of the URLs when users click a video link */
          videos.on('click', function (event) {
            var activePlaylist = $('.playlists__link--active');
            if (!activePlaylist) {
              return;
            }
            var videoLink = $(this).attr('href');
            var activePlaylistId = activePlaylist.attr('data-id');
            if (activePlaylistId && activePlaylistId != 'all') {
              event.preventDefault();
              videoLink = videoLink + '?playlist=' + activePlaylistId;
              window.location.href = videoLink;
            }
          });
        }
        if (playlistLinks && videos) {
          for (var i = 0; i < playlistLinks.length; i++) {
            playlistLinks[i].addEventListener('click', function (e) {
              e.preventDefault();

              var dataID = this.getAttribute('data-id');
              if (dataID == 'all') {
                videos.show();
              } else {
                videos.hide();
                videos.each(function () {
                  var videoPlaylists = $(this).attr('data-id');
                  var videoPlaylistsJson = JSON.stringify(videoPlaylists);
                  if (videoPlaylistsJson.includes(dataID)) {
                    $(this).show();
                  }
                });
              }

              for (var x = 0; x < playlistLinks.length; x++) {
                playlistLinks[x].classList.remove('playlists__link--active');
              }
              this.classList.add('playlists__link--active');
            });
          }
        }
      },

      getCookie: function (name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
        }
        return null;
      },

      setCookie: function (name, value, days) {
        var expires = '';
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
      },

      setupCookiebar: function () {
        if (profet.getCookie('nk_cookie_accept') == null) {
          $('.profet-cookies-info').show();
        }
      },

      /* Generate table of contents automatically based on h2 and h3 tags */
      generateTableOfContents: function () {
        var tableOfContentsWrapper = $('.nk-table-of-contents');
        /* If we can't find a table of contents wrapper, return... */
        if (!tableOfContentsWrapper.length) {
          return;
        }

        var tableOfContentsList = tableOfContentsWrapper.find('.nk-list');

        var tableOfContentsItems = [];
        $('.two-content-columns')
          .find('h2')
          .each(function () {
            tableOfContentsItems.push($(this));
          });
        $('.two-content-columns')
          .find('h3')
          .each(function () {
            tableOfContentsItems.push($(this));
          });
        $.each(tableOfContentsItems, function () {
          var title = $(this).html();
          var slug = profet.convertToSlug(title);
          $(this).attr('id', slug);
          var tableOfContentListItem =
            '<li><a href="#' + slug + '">' + title + '</a></li>';
          tableOfContentsList.append(tableOfContentListItem);
        });
      },

      fadeOutWhenNotInView: function () {
        var elements = $('.fadeout-when-not-in-view');
        /* Set the threshold at 20 % of the window height. E.g., elements fade out when they are in the top 20 % of the window */
        var threshold =
          $(window).scrollTop() + ($(window).outerHeight() / 100) * 25;
        elements.each(function () {
          var elementBottom = $(this).offset().top + $(this).outerHeight();
          if (threshold > elementBottom) {
            if (!$(this).hasClass('element-faded')) {
              $(this).addClass('element-faded');
            }
          } else {
            if ($(this).hasClass('element-faded')) {
              $(this).removeClass('element-faded');
            }
          }
        });
      },

      fadeInWhenInView: function () {
        var elements = $('.fadein-when-in-view');
        /* Set the threshold at 50 % of the window height. */
        var threshold =
          $(window).scrollTop() + ($(window).outerHeight() / 100) * 88;
        elements.each(function () {
          var elementTop = $(this).offset().top;
          if (threshold > elementTop) {
            if (!$(this).hasClass('element-faded-in')) {
              $(this).addClass('element-faded-in');
            }
          }
        });
      },

      /* FAQ stuff */
      /* Select first FAQ item on page load */
      setupFaq: function () {
        if ($('.select-faq-category').length) {
          $('.select-faq-category:first').click();
        }
      },

      selectFaqCategory: function (element) {
        /* Unset all arrows on the categories and readd to the correct element */
        $('.select-faq-category').removeClass('link-arrow-right');
        element.addClass('link-arrow-right');

        var qaId = element.data('qa-id');
        /* Hide all QA divs */
        $('div[data-qa-category]').hide();
        var targetDiv = $('div[data-qa-category=' + qaId + ']');
        targetDiv.fadeIn(500);
      },

      handleInputFileChange: function () {
        /* When the user uploads a file, change the label to the file name */
        $('input[type=file]').change(function () {
          var filename = $(this).val().split('\\').pop();
          $(this).closest('label').find('.file-label').html(filename);
        });
      },

      setupMap: function () {
        var mapModule = document.getElementById('map-module');
        if (mapModule == null) {
          return;
        }

        profet.variables.maps.directionsService =
          new google.maps.DirectionsService();
        profet.variables.maps.directionsDisplay =
          new google.maps.DirectionsRenderer({ suppressMarkers: true });

        var nkLocation = { lat: 59.33156899999999, lng: 18.06331 };
        var parkingLocation = { lat: 59.33086, lng: 18.06321 };
        var subwayLocation = { lat: 59.332108, lng: 18.063389 };
        var trainLocation = { lat: 59.33109, lng: 18.05823 };

        var map = new google.maps.Map(mapModule, {
          center: nkLocation,
          zoom: 15,
        });

        profet.variables.maps.directionsDisplay.setMap(map);

        profet.variables.maps.mapInstance = map;

        var officepin = {
          url: profet.variables.imageDir + 'google-maps-pin-nk.png',
          size: new google.maps.Size(110, 132),
          scaledSize: new google.maps.Size(55, 66),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(25, 66),
          zIndex: 2,
        };

        var parkingpin = {
          url: profet.variables.imageDir + 'google-maps-pin-parking.png',
          size: new google.maps.Size(110, 132),
          scaledSize: new google.maps.Size(55, 66),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(25, 66),
          zIndex: 1,
        };

        var subwaypin = {
          url: profet.variables.imageDir + 'google-maps-pin-subway.png',
          size: new google.maps.Size(110, 132),
          scaledSize: new google.maps.Size(55, 66),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(25, 66),
          zIndex: 1,
        };

        var trainpin = {
          url: profet.variables.imageDir + 'google-maps-pin-train.png',
          size: new google.maps.Size(110, 132),
          scaledSize: new google.maps.Size(55, 66),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(25, 66),
          zIndex: 1,
        };

        profet.addMapMarker(nkLocation, officepin, 'Nordiska Kliniken');
        profet.addMapMarker(parkingLocation, parkingpin, 'Parkering');
        profet.addMapMarker(subwayLocation, subwaypin, 'Tunnelbana');
        profet.addMapMarker(trainLocation, trainpin, 'Tåg');

        for (var i = 0; i < profet.variables.maps.markers.length; i++) {
          profet.variables.maps.markers[i].setMap(map);
        }

        $('.find-clinic-from').on('click', function (event) {
          $('.find-clinic-from').addClass('nk-button-inactive');
          $(this).removeClass('nk-button-inactive');

          var origin = $(this).data('origin');

          switch (origin) {
            case 't-centralen':
              profet.drawMapRoute({ lat: 59.33109, lng: 18.05823 });
              break;
            case 'parking':
              profet.drawMapRoute({ lat: 59.33086, lng: 18.06321 });
              break;
            case 'subway':
              profet.drawMapRoute({ lat: 59.332108, lng: 18.063389 });
              break;
            default:
              return;
          }
        });
      },

      drawMapRoute: function (from) {
        var to = { lat: 59.33156899999999, lng: 18.06331 };

        var request = {
          origin: new google.maps.LatLng(from.lat, from.lng),
          destination: new google.maps.LatLng(to.lat, to.lng),
          travelMode: google.maps.TravelMode.WALKING,
        };

        profet.variables.maps.directionsService.route(
          request,
          function (response, status) {
            if (status == google.maps.DirectionsStatus.OK) {
              profet.variables.maps.directionsDisplay.setDirections(response);
            }
          }
        );
      },

      addMapMarker: function (location, markerIcon, markerTitle) {
        var marker = new google.maps.Marker({
          position: location,
          map: profet.variables.maps.mapInstance,
          animation: google.maps.Animation.DROP,
          title: markerTitle,
          icon: markerIcon,
          zindex: markerIcon.zIndex,
        });
        profet.variables.maps.markers.push(marker);
      },

      setupAgeVerification: function () {
        var ageGates = $('.nk-age-gate');
        if (!ageGates.length) return;

        if (profet.getCookie('nk_age_verified') === '1') {
          ageGates.addClass('nk-age-verified');
          return;
        }

        $('.nk-age-gate-confirm').on('click', function (e) {
          e.preventDefault();
          profet.setCookie('nk_age_verified', '1', 365);
          ageGates.addClass('nk-age-verified');
        });
      },

      setupImageGallery: function () {
        /* Add caption functionality */
        $.featherlightGallery.prototype.afterContent = function () {
          var caption = this.$currentTarget.attr('data-image-caption');
          var warningText = this.$currentTarget.attr('data-image-warning-text');
          this.$instance.find('.caption').remove();
          this.$instance.find('.gallery-warning-text').remove();
          $('<p class="caption text-medium margin-top-xs-1">')
            .text(caption)
            .appendTo(this.$instance.find('.featherlight-content'));
          if (warningText) {
            $('<p class="gallery-warning-text text-small margin-top-xs-1">')
              .text(warningText)
              .appendTo(this.$instance.find('.featherlight-content'));
          }
        };

        $('.featherlight-close-icon').html('Stäng');

        var windowWidth = $(window).width();

        if (windowWidth > 768) {
          $('.nk-image-post').each(function (i, gallery) {
            $(gallery).featherlightGallery({
              variant: 'gal',
              filter: '.gallery-item',
              previousIcon:
                '<img src="' + profet.variables.imageDir + 'arrow-left.svg" />',
              nextIcon:
                '<img src="' +
                profet.variables.imageDir +
                'arrow-right.svg" />',
              galleryFadeIn: 300,
              openSpeed: 300,
              closeIcon:
                '<p class="text-medium"> Stäng <img src="' +
                profet.variables.imageDir +
                'close.svg" /></p>',
            });
          });
        }

        if (windowWidth < 769) {
          $('a.gallery-item').on('click', function (event) {
            event.preventDefault();

            profet.variables.scrollPosOnMenuToggle = $(window).scrollTop();

            var galleryImages = $(this).closest('.nk-image-post').find('a');
            var modal = $('.image-gallery-modal');
            modal.addClass('modal-show');

            $('body').addClass('disable-scroll');

            modal.find('.modal-inner-content').html('');
            var modalTitle = $(this).data('image-post-title');
            galleryImages.each(function () {
              var content = $(this).html();
              modal.find('.modal-inner-content').append(content);
            });
            modal.find('.modal-title').find('h3').html(modalTitle);
          });
        }

        $('.image-gallery-modal')
          .find('.modal-close')
          .on('click', function (event) {
            event.preventDefault();
            $(this).closest('.image-gallery-modal').removeClass('modal-show');
            $('body').removeClass('disable-scroll');

            window.setTimeout(function () {
              $(window).scrollTop(profet.variables.scrollPosOnMenuToggle);
            }, 100);
          });

        /* Handle clicks on gallery filter buttons */
        $('.nk-image-gallery-tag-filter').on('click', function () {
          var tagId = $(this).data('image-gallery-tag-id');

          $('.nk-image-gallery-tag-filter').addClass('nk-button-inactive');
          $(this).removeClass('nk-button-inactive');

          if (tagId == 'all') {
            $('div[data-image-gallery-tag-id]').fadeIn(250);
          } else {
            $('div[data-image-gallery-tag-id]').hide();
            $('div[data-image-gallery-tag-id="' + tagId + '"]').fadeIn(250);
          }
        });
      },

      setupMobileMenu: function () {
        var mobileMenuHamburger = $('.hamburger-menu-mobile');
        var mobileMenuNavigation = $('#header-mobile-main-navigation');
        var headerMobile = $('#header-mobile');
        mobileMenuHamburger.on('click', function (event) {
          event.preventDefault();

          mobileMenuNavigation.toggleClass('toggled');
          headerMobile.toggleClass('toggled');

          if (!$('body').hasClass('mobile-menu-toggled')) {
            profet.variables.scrollPosOnMenuToggle = $(window).scrollTop();
          }

          window.setTimeout(function () {
            let mainNavigation = document.querySelector(
              '#header-mobile-main-navigation'
            );
            $('body').toggleClass('mobile-menu-toggled');
            if (!mobileMenuNavigation.hasClass('toggled')) {
              $(window).scrollTop(profet.variables.scrollPosOnMenuToggle);
              /* Mobile menu has just been closed */
              //enableBodyScroll(mainNavigation);
            } else {
              /* Mobile menu has just been opened */
              //disableBodyScroll(mainNavigation);
            }
          }, 500);
        });

        if (headerMobile.is(':visible')) {
          if (!$('body').hasClass('has-hero-header')) {
            $('body').animate({ paddingTop: headerMobile.outerHeight() }, 250);
          }
        }

        /* On scroll up, set the class .menu-mobile-fixed on the body */
        $(document).on('scroll', function (event) {
          /* If the search box is open, don't do anything... */
          if ($('.search-results-wrapper').is(':visible')) {
            /*
						if(!$('body').hasClass('header-mobile-fixed')) {
							$('body').addClass('header-mobile-fixed');
						}
						return;
						*/
          }

          /* Set if mobile header should have a background or not */
          if (profet.variables.currentScroll > 80) {
            headerMobile.addClass('header-mobile-scrolled');
          } else {
            headerMobile.removeClass('header-mobile-scrolled');
          }
          if (profet.variables.currentScroll > $(document).height() - 200) {
            /* Mobile fix */
            return;
          }

          /*
					if (profet.variables.scrollDirection == 'up' && profet.variables.currentScroll > 200) {
						if (!$('body').hasClass('header-mobile-fixed')) {
							$('body').addClass('header-mobile-fixed');
						} else {
							headerMobile.removeClass('header-mobile-slide-up');
							headerMobile.addClass('header-mobile-slide-down');
						}
					}
					if (profet.variables.scrollDirection == 'down' && profet.variables.currentScroll > 200) {
						if ($('body').hasClass('header-mobile-fixed')) {
							headerMobile.removeClass('header-mobile-slide-down');
							headerMobile.addClass('header-mobile-slide-up');
						}
					}
					*/
        });
      },

      setupSearchPlaceholderCarousel: function () {
        return; // We don't use this function any more
        var searchCarousel = $('.placeholder-carousel');
        var currentPlaceholder = searchCarousel.html();
        var nextPlaceholder =
          profet.variables.searchPlaceholders[
            Math.floor(
              Math.random() * profet.variables.searchPlaceholders.length
            )
          ];

        if (nextPlaceholder == currentPlaceholder) {
          profet.setupSearchPlaceholderCarousel();
          return;
        }

        searchCarousel.fadeOut(500);
        window.setTimeout(function () {
          searchCarousel.html(nextPlaceholder);
          searchCarousel.fadeIn(500);
          /*searchCarousel.css('top', '100px');
					searchCarousel.animate({top: '0px'}, 500);*/
        }, 500);

        window.setTimeout(function () {
          profet.setupSearchPlaceholderCarousel();
        }, 4000);
      },

      getPartPaymentCostPerMonth: function (amount, options) {
        amount = Number(amount);
        options = options || {};
        var months = options.months > 0 ? options.months : 24;
        var setupFee = isFinite(options.setupFee) ? options.setupFee : 575;
        var adminFee = isFinite(options.adminFee) ? options.adminFee : 55;
        // Monthly cost = (loan + setup fee) spread over the months + the
        // recurring monthly admin fee.
        var calculation = (amount + setupFee) / months + adminFee;
        calculation = Math.floor(calculation);
        return calculation.toLocaleString('sv-SE');
      },

      setupPartPaymentSlider: function () {
        var partPaymentWrappers = $('.part-payment');
        if (!partPaymentWrappers.length) {
          return;
        }

        // Initialise each module instance independently so several
        // part-payment modules can live on the same page.
        partPaymentWrappers.each(function () {
          var wrapper = $(this);
          var slider = wrapper.find('.part-payment-slider');
          var loanAmountSpan = wrapper.find('.loan-amount');
          var paymentAmountSpan = wrapper.find('.payment-amount');

          // Fees / repayment period are fed in via data attributes on the
          // wrapper so each module instance can use its own values.
          var options = {
            months: Number(wrapper.data('months')) || 24,
            setupFee: Number(wrapper.data('setup-fee')),
            adminFee: Number(wrapper.data('admin-fee')),
          };

          var updateAmounts = function (numberValue) {
            loanAmountSpan.html(numberValue.toLocaleString('sv-SE'));
            paymentAmountSpan.html(
              profet.getPartPaymentCostPerMonth(numberValue, options)
            );
          };

          updateAmounts(Number(slider.val()));

          slider.on('input', function () {
            updateAmounts(Number($(this).val()));
          });
        });
      },

      setupYoutubeVideoPlayer: function () {
        $('.nk-video-link').on('click', function (event) {
          event.preventDefault();

          profet.variables.scrollPosOnMenuToggle = $(window).scrollTop();

          var videoUrl = $(this).data('video-url');
          var videoTitle = $(this).find('p').html();
          var modal = $('.video-player-modal');
          modal.addClass('modal-show');
          modal.find('iframe').attr('src', videoUrl);
          modal.find('h3').html(videoTitle);

          $('body').addClass('disable-scroll');
        });

        $('.video-player-modal')
          .find('.modal-close')
          .on('click', function (event) {
            var modal = $('.video-player-modal');
            modal.removeClass('modal-show');
            modal.find('iframe').attr('src', '');
            $('body').removeClass('disable-scroll');

            window.setTimeout(function () {
              $(window).scrollTop(profet.variables.scrollPosOnMenuToggle);
            }, 100);
          });
      },

      loadYoutubeVideo: function (element) {
        var youtubeId = element.attr('data-youtube-id');
        /* Hide the video element */
        element.hide();
        /* Show the youtube iframe player and load the correct video id */
        var youtubePlayerWrapper = element
          .closest('.video-wrapper')
          .find('.youtube-video-player');
        if (!youtubePlayerWrapper.length) {
          var youtubePlayerWrapper = element.siblings('.youtube-video-player');
        }
        var youtubePlayer = youtubePlayerWrapper.find('iframe');
        youtubePlayer.attr(
          'src',
          'https://www.youtube.com/embed/' +
            youtubeId +
            '?autoplay=1&showinfo=0&controls=1&rel=0&playsinline=1'
        );
        youtubePlayerWrapper.show();
      },

      loadYoutubeVideoFromPlaylist: function (element) {
        var youtubeId = element.attr('data-youtube-id');
        var videoTargetContainer = element.attr('data-nk-video-target');
        var videoTargetContainerElement = $(videoTargetContainer);
        videoTargetContainerElement.find('video').hide();
        /* Show the youtube iframe player and load the correct video id */
        var youtubePlayerWrapper = videoTargetContainerElement.find(
          '.youtube-video-player'
        );
        var youtubePlayer = youtubePlayerWrapper.find('iframe');
        youtubePlayer.attr(
          'src',
          'https://www.youtube.com/embed/' +
            youtubeId +
            '?autoplay=1&showinfo=0&controls=1&rel=0&playsinline=1'
        );
        youtubePlayerWrapper.show();
      },

      showBookTimePopup: function () {
        $('.close-book-time-popup').on('click', function () {
          $(this)
            .closest('.book-time-popup')
            .removeClass('book-time-popup-toggled');
          $(this)
            .closest('.book-time-popup')
            .addClass('book-time-popup-closed');
        });

        $(window).on('scroll', function () {
          var popupTrigger = $('.book-time-popup-trigger');
          popupTrigger.each(function () {
            var element = $(this);
            var popupId = $(this).data('book-time-popup-id');
            var popup = $(
              '.book-time-popup[data-book-time-popup-id="' + popupId + '"]'
            );

            if (
              profet.variables.currentScroll > element.offset().top &&
              !popup.hasClass('book-time-popup-closed') &&
              !popup.hasClass('book-time-popup-toggled')
            ) {
              popup.addClass('book-time-popup-toggled');
            }

            /* If the user has scrolled to the top 1/3rd of the page, hide the popup */
            if (
              profet.variables.currentScroll < $(window).height() / 3 &&
              !popup.hasClass('book-time-popup-closed') &&
              popup.hasClass('book-time-popup-toggled')
            ) {
              popup.removeClass('book-time-popup-toggled');
            }
          });
        });
      },
      showBannerPopup: function () {
        $('.close-banner-popup').on('click', function () {
          $(this).closest('.banner-popup').removeClass('banner-popup-toggled');
          $(this).closest('.banner-popup').addClass('banner-popup-closed');
        });

        $(window).on('scroll', function () {
          var popupTrigger = $('.banner-popup-trigger');
          popupTrigger.each(function () {
            var element = $(this);
            var popupId = $(this).data('banner-popup-id');
            var popup = $(
              '.banner-popup[data-banner-popup-id="' + popupId + '"]'
            );

            if (
              profet.variables.currentScroll > element.offset().top &&
              !popup.hasClass('banner-popup-closed') &&
              !popup.hasClass('banner-popup-toggled')
            ) {
              popup.addClass('banner-popup-toggled');
            }

            /* If the user has scrolled to the top 1/3rd of the page, hide the popup */
            if (
              profet.variables.currentScroll < $(window).height() / 3 &&
              !popup.hasClass('banner-popup-closed') &&
              popup.hasClass('banner-popup-toggled')
            ) {
              popup.removeClass('banner-popup-toggled');
            }
          });
        });
      },

      /**
       * Resolve the clinic city from the closest wrapper element.
       * Works for both native DOM elements and jQuery objects.
       */
      getClinicCityFromForm: function (formEl) {
        var el = formEl instanceof jQuery ? formEl[0] : formEl;
        if (!el) return '';
        var wrapper = el.closest('.nk-clinic-contact-form[data-clinic-city]');
        if (wrapper) return wrapper.getAttribute('data-clinic-city') || '';
        var section = el.closest('.clinic-contact-section[data-clinic-city]');
        if (section) return section.getAttribute('data-clinic-city') || '';
        if (document.body.classList.contains('single-profet_clinic')) {
          var clinicWrapper = document.querySelector(
            '.nk-clinic-contact-form[data-clinic-city]'
          );
          if (clinicWrapper)
            return clinicWrapper.getAttribute('data-clinic-city') || '';
        }
        return '';
      },

      /**
       * Inject a hidden clinic_city input into every CF7 form that lives
       * inside a .nk-clinic-contact-form[data-clinic-city] wrapper.
       */
      injectClinicCityFields: function () {
        var self = this;
        document
          .querySelectorAll('.nk-clinic-contact-form[data-clinic-city]')
          .forEach(function (wrapper) {
            var city = wrapper.getAttribute('data-clinic-city') || '';
            wrapper.querySelectorAll('.wpcf7-form').forEach(function (form) {
              if (form.querySelector('input[name="clinic_city"]')) return;
              var hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = 'clinic_city';
              hidden.value = city;
              form.appendChild(hidden);
            });
          });
      },

      setupContactForm7Tracking: function () {
        var self = this;

        self.injectClinicCityFields();

        // JS event path — fires when CF7 sends mail via AJAX
        document.addEventListener(
          'wpcf7mailsent',
          function (event) {
            console.log('🔍 Contact Form 7 Mail Sent Event:', event.detail);
            var formId = event.detail.contactFormId;
            var formEl = event.target;
            var city = self.getClinicCityFromForm(formEl);

            window.dataLayer = window.dataLayer || [];

            var isClinicForm = !!city;

            if (formId == '379') {
              console.log(
                '✅ Phone consultation form submitted via JS event - ID 379'
              );
              window.dataLayer.push({
                event: 'send',
                eventModel: {
                  event_category: 'ContactForm',
                  event_label: 'Phone consultation',
                },
              });
            } else if (formId == '434' || isClinicForm) {
              console.log(
                '✅ Contact form submitted via JS event - ID',
                formId + ', city:',
                city || '(none)'
              );
              var payload = {
                event: 'kontaktformular',
                event_category: 'ContactForm',
                event_label: 'Contact page',
              };
              if (city) {
                payload.city = city;
              }
              window.dataLayer.push(payload);
            } else {
              console.log('ℹ️ Other form submitted via JS event - ID:', formId);
            }
          },
          false
        );

        /*
				document.addEventListener( 'wpcf7mailsent', function( event ) {
					if ( '379' == event.detail.contactFormId ) {
						fbq('track', 'Lead');
					}
					if ( '323' == event.detail.contactFormId ) {
						dataLayer.push({'event': 'gtm4wp.contactForm7Submitted323'});
					}
					if ( '2585' == event.detail.contactFormId ) {
						dataLayer.push({'event': 'gtm4wp.contactForm7Submitted2585'});
					}
				    
				}, false );
				*/

        // HTML submit path — fires when the page reloads after CF7 submission
        var mailSentOkMessage = $('.wpcf7-form.sent');
        if (mailSentOkMessage.length > 0) {
          var contactForm = mailSentOkMessage.closest('.wpcf7');
          var contactFormId = contactForm.attr('id');
          console.log('🔍 Contact Form 7 Debug - Form ID:', contactFormId);
          // Match both 3-digit IDs (434, 379, 10) and 5-digit clinic-specific IDs (14488, 14489, 14490)
          var contactFormIdNumber = contactFormId.match('-f\\d+-');

          if (contactFormIdNumber && contactFormIdNumber.length > 0) {
            var contactFormIdString = contactFormIdNumber[0];
            contactFormIdString = contactFormIdString.replace('-f', '');
            contactFormIdString = contactFormIdString.replace('-', '');

            console.log(
              '🔍 Contact Form 7 Debug - Parsed Form ID:',
              contactFormIdString
            );

            var city = self.getClinicCityFromForm(contactForm);
            window.dataLayer = window.dataLayer || [];

            if (contactFormIdString == '10') {
              window.dataLayer.push({
                event: 'send',
                event_category: 'ContactForm',
                event_label: 'Newsletter form in footer',
              });
            }

            var isClinicForm = !!city;

            if (contactFormIdString == '434' || isClinicForm) {
              var payload = {
                event: 'kontaktformular',
                event_category: 'ContactForm',
                event_label: 'Contact page',
              };
              if (city) {
                payload.city = city;
              }
              window.dataLayer.push(payload);
            }

            if (contactFormIdString == '379') {
              console.log('✅ Phone consultation form detected - ID 379');
              window.dataLayer.push({
                event: 'send',
                event_category: 'ContactForm',
                event_label: 'Phone consultation',
              });
            } else if (
              contactFormIdString != '10' &&
              contactFormIdString != '434' &&
              !isClinicForm
            ) {
              console.log(
                'ℹ️ Generic contact form tracking for ID:',
                contactFormIdString
              );
              window.dataLayer.push({
                event: 'send',
                event_category: 'ContactForm',
              });
            }
          }
        }
      },

      /**
       * Track clicks on tel: and mailto: links across the entire site.
       * Pushes events to dataLayer using the same format as the old
       * Contact Form 7 tracking, so existing GTM triggers, GA4 tags
       * and Google Ads conversions fire automatically.
       */
      setupContactClickTracking: function () {
        var self = this;
        document.addEventListener('click', function (event) {
          var link = event.target.closest('a');
          if (!link) return;

          var href = link.getAttribute('href');
          if (!href) return;

          var isPhone = href.indexOf('tel:') === 0;
          var isEmail = href.indexOf('mailto:') === 0;
          if (!isPhone && !isEmail) return;

          window.dataLayer = window.dataLayer || [];

          var pathname = window.location.pathname;
          var isContactPage = pathname.indexOf('/kontakt') > -1;
          var isClinicPage =
            document.body.classList.contains('single-profet_clinic') ||
            pathname.indexOf('/klinik') > -1;

          var eventLabel = 'Contact page';

          var city = self.getClinicCityFromForm(link);

          var payload = {
            event: 'send',
            event_category: 'ContactForm',
            event_label: eventLabel,
            contact_method: isPhone ? 'phone' : 'email',
            contact_value: isPhone
              ? href.replace('tel:', '').trim()
              : href.replace('mailto:', '').trim(),
            page_type: isContactPage
              ? 'contact_page'
              : isClinicPage
                ? 'clinic_page'
                : 'other',
          };
          if (city) {
            payload.city = city;
          }
          window.dataLayer.push(payload);
        });
      },

      detectBrowser: function () {
        /* https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie-with-jquery */

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');

        /* Check if the user is using IE */
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
          $('body').addClass('ms-ie');
        }
      },

      /* Detect search crawlers / headless browsers (Lighthouse, Selenium, etc.).
			Bots never trigger the hero video — they only ever see the first-frame
			poster image, which keeps audits light and layout stable. */
      isBot: function () {
        return /bot|crawl|spider|slurp|googlebot|bingbot|yandex|baidu|duckduckbot|facebookexternalhit|twitterbot|linkedinbot|embedly|quora|pinterest|redditbot|applebot|lighthouse|headless|phantom|selenium/i.test(
          navigator.userAgent
        );
      },

      /* Swap in the real video source and start playback for whichever hero
			video (mobile/desktop) is currently visible. */
      loadHeroVideo: function () {
        var videoSources = $('.profet-hero-header')
          .find('.video-wrapper')
          .find('source');
        videoSources.each(function () {
          var parent = $(this).closest('.video-wrapper');
          var video = $(this).closest('video');

          if (parent.is(':visible') == false) {
            return true;
          }

          if ($(this).attr('src') != '') {
            return true;
          }

          var realSource = $(this).attr('data-real-src');
          $(this).attr('src', realSource);
          video[0].load();
          var playPromise = video[0].play();
          if (playPromise && typeof playPromise.catch === 'function') {
            // Ignore autoplay rejections (e.g. low power mode) — the poster stays.
            playPromise.catch(function () {});
          }
        });
      },

      /* Divert loading of the hero header video until the visitor's first
			interaction. Until then the first-frame poster image is shown, which
			avoids downloading/decoding the video on initial paint (better CLS/LCP).
			Bots/crawlers never load the video at all. */
      setupVideoLoading: function () {
        if (profet.variables.heroVideoStarted) {
          return;
        }

        // Bots only ever see the first-frame poster image.
        if (profet.isBot()) {
          return;
        }

        // Respect reduced-motion: keep the first-frame poster permanently and
        // never load/autoplay the hero video (WCAG 2.2.2).
        if (
          window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
          return;
        }

        if ($('.profet-hero-header').find('.video-wrapper').length === 0) {
          return;
        }

        if (profet.variables.heroVideoListenersBound) {
          return;
        }
        profet.variables.heroVideoListenersBound = true;

        var startHeroVideo = function () {
          if (profet.variables.heroVideoStarted) {
            return;
          }
          profet.variables.heroVideoStarted = true;
          $(document).off('.heroVideo');
          profet.loadHeroVideo();
        };

        $(document).on(
          'scroll.heroVideo click.heroVideo touchstart.heroVideo keydown.heroVideo pointerdown.heroVideo mousemove.heroVideo',
          startHeroVideo
        );
      },

      maybeShowRedirectModal: function () {
        /* Check if the user is a search crawler. If so, return */
        var botPattern =
          '(googlebot/|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)';
        var re = new RegExp(botPattern, 'i');
        var userAgent = navigator.userAgent;
        if (re.test(userAgent)) {
          return;
        }

        /* Check if there's a query parameter set for the redirect modal */
        var uri = window.location.search.substring(1);
        var params = new URLSearchParams(uri);
        if (params.get('redirect_modal')) {
          $('.redirect-overlay').show();
        }
      },

      hideThumbnail: function () {
        var inlineVideoBlocks = document.querySelectorAll(
          '.text-and-video--video-inline'
        );
        if (inlineVideoBlocks.length > 0) {
          inlineVideoBlocks.forEach((block) => {
            var thumbnail = block.querySelector('.video__thumbnail');
            var iframe = block.querySelector('iframe');
            thumbnail.addEventListener('click', (e) => {
              thumbnail.style.display = 'none';
              iframe.contentWindow.postMessage(
                '{"event":"command","func":"playVideo","args":""}',
                '*'
              );
            });
          });
        }
      },

      videosHeroSearch: function () {
        // Ajax search
        var heroBlock = document.querySelector('section.din-resa-hero');

        if (heroBlock) {
          const searchInput = heroBlock.querySelector('#search-video');
          const searchResultsContainer =
            heroBlock.querySelector('.search-results');

          const valueOrZero = (v) => {
            return v !== '' ? v : '0';
          };

          const getVideos = () => {
            let searchTerm = searchInput.value;
            // Relative, so REST stays same-origin on the campaign host.
            let videosRequestURL =
              '/wp-json/nk/getVideos/' +
              valueOrZero(searchTerm) +
              '/';
            searchResultsContainer.innerHTML =
              '<div class="search-results__error-message">' +
              profetWPVars.videosLoadingMsg +
              '</div>';
            searchResultsContainer.classList.add('visible');

            fetch(videosRequestURL, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              },
            })
              .then((res) => {
                return res.json();
              })
              .then((res) => {
                let html = '';

                if (res.data.length > 0) {
                  res.data.forEach((item) => {
                    html +=
                      '<a href="' +
                      item.link +
                      '" class="search-results__video-link">' +
                      item.title +
                      '</a>';
                  });
                } else {
                  html +=
                    '<div class="search-results__error-message">' +
                    profetWPVars.videosSearchErrorMsg +
                    '</div>';
                }

                searchResultsContainer.innerHTML = html;
              })
              .then(() => {});
          };

          const closeFoundVideos = () => {
            searchResultsContainer.classList.remove('visible');
            searchResultsContainer.innerHTML = '';
          };

          searchInput.addEventListener('keyup', () => {
            if (searchInput.value.length > 1) {
              getVideos();
            } else {
              closeFoundVideos();
            }
          });

          const body = document.querySelector('body');

          body.addEventListener('click', (e) => {
            if (
              searchResultsContainer.classList.contains('visible') &&
              !e.target.parentElement.classList.contains('search-results') &&
              !e.target.parentElement.classList.contains('search-wrapper') &&
              !e.target.classList.contains('search-results__video-link') &&
              e.target.id !== 'search-video'
            ) {
              closeFoundVideos();
            }
          });

          // Desktop horizontal scroll
          let mouseDown = false;
          let startX, scrollLeft;
          const slider = document.querySelector(
            '.din-resa-hero__selected-videos'
          );

          const startDragging = (e) => {
            mouseDown = true;
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
          };

          const stopDragging = (e) => {
            mouseDown = false;
            slider.classList.remove('moving');
          };

          const move = (e) => {
            if (mouseDown) {
              slider.classList.add('moving');
            }
            e.preventDefault();

            if (!mouseDown) {
              return;
            }
            const x = e.pageX - slider.offsetLeft;
            const scroll = x - startX;
            slider.scrollLeft = scrollLeft - scroll;
          };

          // Add the event listeners
          slider.addEventListener('mousemove', move, false);
          slider.addEventListener('mousedown', startDragging, false);
          slider.addEventListener('mouseup', stopDragging, false);
          slider.addEventListener('mouseleave', stopDragging, false);

          // Mobile event listeners
          // slider.addEventListener('touchstart', move, false);
          // slider.addEventListener('touchmove', startDragging, false);
          // slider.addEventListener('touchend', stopDragging, false);
          // slider.addEventListener('touchcancel', stopDragging, false);
        }
      },

      singleVideoTemplate: function () {
        // Switch Playlist
        var switchPlaylistBlock = document.querySelector(
          '.single-videos__playlists'
        );

        if (switchPlaylistBlock) {
          var playlistsDropdown = switchPlaylistBlock.querySelector(
            '.playlists__dropdown'
          );
          var currentPlaylist = switchPlaylistBlock.querySelector(
            '.playlists__current'
          );

          currentPlaylist.addEventListener('click', (e) => {
            e.preventDefault();

            if (!playlistsDropdown.classList.contains('opened')) {
              currentPlaylist.classList.add('link-close-right');
              playlistsDropdown.classList.add('opened');
            } else {
              currentPlaylist.classList.remove('link-close-right');
              playlistsDropdown.classList.remove('opened');
            }
          });

          var body = document.querySelector('body');

          body.addEventListener('click', (e) => {
            if (
              playlistsDropdown.classList.contains('opened') &&
              !e.target.parentElement.classList.contains(
                'playlists__dropdown'
              ) &&
              !e.target.classList.contains('playlists__current')
            ) {
              currentPlaylist.classList.remove('link-close-right');
              playlistsDropdown.classList.remove('opened');
            }
          });
        }

        // Play Video
        var videoBlock = document.querySelector('.single-videos .main-video');

        if (videoBlock) {
          var videoWrapper = videoBlock.querySelector('.main-video__wrapper');
          var videoIframe = videoBlock.querySelector('.main-video iframe');
          var videoPlayBtn = videoBlock.querySelector(
            '.main-video__play-button'
          );
          var videoThumbnail = videoBlock.querySelector(
            '.main-video__thumbnail'
          );
          var videInfo = videoBlock.querySelector('.main-video__info');

          function hideImagePlayVideo() {
            videoPlayBtn.style.display = 'none';
            videoThumbnail.style.display = 'none';
            videInfo.style.display = 'none';

            // Start playing video when hiding image
            videoIframe.contentWindow.postMessage(
              '{"event":"command","func":"playVideo","args":""}',
              '*'
            );
          }

          videoPlayBtn.addEventListener('click', () => {
            hideImagePlayVideo();
          });
          videoThumbnail.addEventListener('click', () => {
            hideImagePlayVideo();
          });
        }

        // Q&A
        var questionsAndAnswers = document.querySelector(
          '.single-videos .questions-and-answers'
        );

        if (questionsAndAnswers) {
          var questions = questionsAndAnswers.querySelectorAll('.question');
          questions.forEach((question) => {
            question.addEventListener('click', (e) => {
              e.preventDefault();

              if (!question.classList.contains('opened')) {
                question.classList.add('opened');
                question.classList.add('link-close-right');
                question.nextElementSibling.style.display = 'block';
              } else {
                question.classList.remove('opened');
                question.classList.remove('link-close-right');
                question.nextElementSibling.style.display = 'none';
              }
            });
          });
        }
      },

      selectPlaylistByQueryParameter: function () {
        // Get the query parameter for "show_playlist" if it exists
        var urlParams = new URLSearchParams(window.location.search);

        var playlistParam = urlParams.get('show_playlist');
        if (!playlistParam) return;

        var playlistsBlock = document.querySelector('.playlists-block');
        if (!playlistsBlock) return;

        // Set the value of '.playlists__dropdown' to the query parameter
        var playlistsDropdown = document.querySelector('.playlists__dropdown');
        if (playlistsDropdown) {
          playlistsDropdown.value = playlistParam;
        }
        // Find and click the '.playlists__link' with the corresponding 'data-id', and select it
        var playlistLink = Array.from(
          document.querySelectorAll('.playlists__link')
        ).find((link) => link.getAttribute('data-id') === playlistParam);
        if (playlistLink) {
          playlistLink.click();
        }
        playlistsBlock.scrollIntoView();
      },
    };

    profet.init();
  });
})(jQuery);
